import { ImagesHolder } from "../../image_loader/images_holder.js";
import { ImgID } from "../../image_loader/img_id.js";
import { TransformOptions, UIElement } from "./ui_element.js";
import { mountDomSyncImage } from "../dom_backend/dom_backend.js";

export class UIBackgroundFitHeight extends UIElement
{
  private img_id: ImgID;

  constructor(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    img_id: ImgID,
    options?: TransformOptions,
  )
  {
    super(
      ctx,
      x,
      y,
      width,
      height,
      false,
      false,
      options
    );

    this.img_id = img_id;
  }

  public setImgId(
    img_id: ImgID
  ): void
  {
    this.img_id = img_id;
  }

  public name(): string
  {
    return "UIBackgroundFitHeight";
  }

  private dom_last_key = "";
  private dom_img: HTMLImageElement | null = null;

  protected override syncDomContent( node: HTMLElement ): boolean
  {
    const url = ImagesHolder.getUrl( this.img_id );
    const image = ImagesHolder.getNaturalSize( this.img_id );
    if ( !url || !image || image.width <= 1 )
      return false;

    const target_w = this.rect.getW();
    const target_h = this.rect.getH();
    const draw_w = Math.max( image.width * ( target_h / image.height ), target_w );
    const key = `${url}|${draw_w}|${target_h}`;
    if ( key === this.dom_last_key )
      return true;
    this.dom_last_key = key;

    this.dom_img = mountDomSyncImage( node, this.dom_img, url );
    const s = this.dom_img.style;
    s.left = `${( target_w - draw_w ) / 2}px`;
    s.width = `${draw_w}px`;
    s.height = `${target_h}px`;
    return true;
  }

  public render(): void
  {
    if ( !this.shouldBeRendered() )
      return;

    this.startRender();
    if ( this.isDomNative() )
    {
      this.finishRender();
      return;
    }
    this.applyTransform();

    this.ctx.save();
    this.ctx.translate(
      -this.rect.getW2(),
      0
    );

    const image = ImagesHolder.getImage(
      this.img_id
    );

    const image_w = image.width;
    const image_h = image.height;

    const target_w = this.rect.getW();
    const target_h = this.rect.getH();

    const scale = target_h / image_h;

    let draw_w = image_w * scale;

    if ( draw_w < target_w )
    {
      draw_w = target_w;
    }

    const draw_x = ( target_w - draw_w ) / 2;
    const draw_y = -target_h / 2;

    this.ctx.drawImage(
      image,
      draw_x,
      draw_y,
      draw_w,
      target_h
    );

    this.ctx.restore();

    this.finishRender();
  }
}